var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecurringBuy = function SvgRecurringBuy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m.273 3.367a.293.293 0 0 0-.545 0l-.147.354a2.53 2.53 0 0 1-1.303 1.347l-.416.185a.307.307 0 0 0 0 .558l.44.196c.572.254 1.03.719 1.285 1.303l.143.328c.104.24.436.24.54 0l.143-.328a2.53 2.53 0 0 1 1.285-1.303l.44-.196a.307.307 0 0 0 0-.558l-.415-.185a2.53 2.53 0 0 1-1.304-1.347z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.936 11A7.998 7.998 0 0 0 4.428 9.428L6 11H2V7l.885.885A10 10 0 0 1 12 2c5.185 0 9.449 3.947 9.95 9zM12 22c-5.185 0-9.448-3.947-9.95-9h2.014a7.999 7.999 0 0 0 15.509 1.573L18 13h4v4l-.884-.884A10 10 0 0 1 12 22"
  })));
};
export default SvgRecurringBuy;